<template>
  <div v-if="socialLoginStatus" class="mt20 center-xs sign-in-wrapper">
    <no-ssr>
      <div v-if="!facebookFailed" id="fSignInWrapper" :style="{ visibility: facebookReady ? 'visible' : 'hidden' }">
        <button type="button" id="facebook" class="google-button" @click="facebookAuthenticate">
          <span class="google-button__icon">
            <img src="../../../../assets/SocialLogin/facebook.svg" width="20" height="20" alt="Facebook"
              loading="lazy"
              fetchpriority="auto"
            >
          </span>
          <span class="google-button__text"> {{ $t('Sign in with Facebook') }} </span>
        </button>
      </div>
    </no-ssr>
    <br>
    <div :id="`gSignInWrapper-${index}`">
      <button type="button" :id="`google-${index}`" class="google-button" v-google-identity-btn="{ clientId, locale: 'uk', width: 200 }">
        <span class="google-button__icon">
          <img src="../../../../assets/SocialLogin/google2.svg" width="20" height="20" alt="Google"
            loading="lazy"
            fetchpriority="auto"
          >
        </span>
        <span class="google-button__text"> {{ $t('Sign in with Google') }} </span>
      </button>
    </div>
  </div>
</template>

<script async>
import NoSSR from 'vue-no-ssr'
import config from 'config'
import { mapActions, mapGetters } from 'vuex'
import GoogleIdentityBtn from 'theme/directives/google-identity-btn'
import { loadFacebookSDK } from 'src/modules/social-login/helpers/facebook-sdk'

export default {
  components: {
    'no-ssr': NoSSR
  },

  directives: {
    GoogleIdentityBtn
  },
  props: {
    index: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      isGoogleAuthLoading: true,
      facebookReady: false,
      facebookFailed: false
    }
  },

  computed: {
    ...mapGetters({
      getGeneralSettings: 'configs/getGeneralSettings'
    }),
    socialLoginStatus () {
      return this.getGeneralSettings.find(general => general.key === 'social_login_status').value
    },
    clientId () {
      return config.socialLogin.clientIdGoogle
    }
  },

  mounted () {
    if (this.socialLoginStatus) {
      loadFacebookSDK()
        .then(() => { this.facebookReady = true })
        .catch(error => {
          this.facebookFailed = true
          console.error('Facebook SDK failed to load: ', error)
        })
    }
  },

  methods: {
    ...mapActions({
      googleAuthenticate: 'social-login/googleAuthenticate',
      facebookAuthenticate: 'social-login/facebookAuthenticate'
    }),
    onGoogleAuthSuccess (jwtCredentials) {
      this.googleAuthenticate(jwtCredentials)
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-in-wrapper{
  display: flex;
  justify-content: space-evenly;

  @media only screen and (max-width: 991px) {
    justify-content: space-between;
  }

  @media (max-width: 440px) {
    display: block;
  }
}
#facebook {
  background: #3b5998;
  color: #fff;
}
.google-button {
  margin:0;
  height: 40px;
  border-width: 0;
  border-radius: 5px;
  overflow: hidden;
  white-space: nowrap;
  border-color: #000;
  -webkit-box-shadow: 1px 1px 0px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.05);
  -webkit-transition-property: background-color, -webkit-box-shadow;
  transition-property: background-color, -webkit-box-shadow;
  -o-transition-property: background-color, box-shadow;
  transition-property: background-color, box-shadow;
  transition-property: background-color, box-shadow, -webkit-box-shadow;
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  -webkit-transition-timing-function: ease-in-out;
  -o-transition-timing-function: ease-in-out;
  transition-timing-function: ease-in-out;
  padding: 0;
  &:focus,
  &:hover {
    box-shadow: 1px 4px 5px 1px rgba(0,0,0,0.1);
  }
  &:active {
    background-color: #e5e5e5;
    box-shadow: none;
    transition-duration: 10ms;
  }
  @media (max-width: 440px) {
    margin: auto;
  }
}
.google-button__icon {
  display: inline-block;
  vertical-align: middle;
  margin: 8px 0 8px 8px;
  width: 18px;
  height: 18px;
  box-sizing: border-box;
}
.google-button__icon--plus {
  width: 27px;
}
.google-button__text {
  display: inline-block;
  vertical-align: middle;
  padding: 0 24px;
  font-size: 14px;
  font-weight: bold;
  font-family: 'TTNorms Regular',arial,sans-serif;
}

</style>
